import { Pipe, PipeTransform } from '@angular/core';
import { MultiLingualService } from 'app/BaseFramework/core/services/multi-lingual/multi-lingual.service';
import { I18nService } from 'app/BaseFramework/core/services/i18n/i18n.service';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';

@Pipe({
  name: 'MMSTranslate',
  pure: false
})
/***
 * Usage: 
 * {{"汉字" | MMSTranslate:'T2S'}} // Traditional Chinese to Simple Chinese
 * {{"Something" | MMSTranslate}} // From English to Current Application Language
 * {{"汉字" | MMSTranslate:'S2T'}} // Simple Chinese to Traditional Chinese
 * {{"Something" | MMSTranslate:'En2S'}} // From English to Simple Chinese
 * {{"Something" | MMSTranslate:'En2T'}} // From English to Traditional Chinese
 */
export class MMSTranslatePipe implements PipeTransform {

  constructor(
    private multilingualService?: MultiLingualService,
    private i18nService?: I18nService,
    private commonUtility?: CommonUtilty
  ) { }

  transform(value: any, args?: any): any {
    let output
    switch (args) {
      //traditional chinese to simple chinese
      case 'T2S':
        output = this.multilingualService.ConvertChineseT2S(value);
        break;
      // simple chinese to traditional chinese 
      case 'S2T':
        output = this.multilingualService.ConvertChineseS2T(value);
        break;
      //English to simple chinese
      case 'En2S':
        output = this.multilingualService.ConvertChineseT2S(this.extractLabel(value));
        break;
      //English to tradition chinese
      case 'En2T':
        output = this.multilingualService.ConvertChineseS2T(this.extractLabel(value));
        break;
      // Normal Translate based on default language
      default:
        output = this.extractLabel(value);
        break;
    }

    return output
  }

  extractLabel(value) {
    if (value && this.commonUtility.isArrayIterable(this.multilingualService.listOfLocales) && this.i18nService.language) {

      let currentLanguageLocale = this.multilingualService.listOfLocales.find(res => res.languageCd === this.i18nService.language)
      return currentLanguageLocale && currentLanguageLocale.labels[value] ? currentLanguageLocale.labels[value] : value;

    }
    else
      return value
  }
}
